import React from "react";
import {publicRoutesPath } from '../Routes/index';
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuthenticationData } from "../Components/CustomHooks/useAuthenticationData";

const Authentication = props => {
    
    const dispatch = useDispatch();
    
    const token = localStorage.getItem('accessToken');
    const currentUser = useSelector(state => state?.owner?.currentuser);
    

useAuthenticationData();

    if (token) {
        if (currentUser?.resetPassword === true) {
            return <Redirect to={publicRoutesPath.FIRST_USER_PASSWORD_SETUP} />;
        }
        return props.children;
    }

    return <Redirect to={publicRoutesPath.LOGIN} />;
    
   
   
};

export default Authentication;
